/**
 * @generated SignedSource<<9cd5c2391142e936255255ab047bc71a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventDetailRedesignedHeader$data = {
  readonly eventSeries: {
    readonly facility: {
      readonly club: {
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"ClubLogo_Club">;
      } | null | undefined;
    };
  };
  readonly " $fragmentType": "EventDetailRedesignedHeader";
};
export type EventDetailRedesignedHeader$key = {
  readonly " $data"?: EventDetailRedesignedHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventDetailRedesignedHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventDetailRedesignedHeader",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSeries",
      "kind": "LinkedField",
      "name": "eventSeries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ClubLogo_Club"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "9b6d61c27080d693b1b3639ade7ee313";

export default node;
